<template>
  <div class="flex flex-col space-y-10">
    <div class="flex justify-between">
      <statistics-card-line
        class="mx-2 pb-4"
        icon="AwardIcon"
        :statistic="total_of_applications"
        statisticTitle="Total de candidaturas"
        :chartData="subscribersGainedChartData"
        type="area"
      />
      <statistics-card-line
        class="mx-2"
        icon="FileTextIcon"
        :statistic="total_of_vacancies"
        statisticTitle="Total de vagas"
        :chartData="subscribersGainedChartData"
        type="area"
        color="warning"
      />
    </div>
    <div class="flex flex-col">
      <div class="flex flex-col my-8" v-if="last_vacancies.length > 0">
        <vs-label class="my-5">Últimas vagas</vs-label>
        <div class="nxp-vacancy-cards">
          <div v-for="vacancy in last_vacancies" :key="`vacancy-${vacancy}`">
            <VacancyCard
              :key="`vacancy-card-${vacancy.id}`"
              :vacancy="vacancy"
              :isOpen="true"
            />
          </div>
        </div>
      </div>
      <div class="flex flex-col" v-if="last_applications.length > 0">
        <vs-label class="my-5">Últimas candidaturas</vs-label>
        <div class="nxp-vacancy-cards">
          <div
            v-for="application in last_applications"
            :key="`vacancy-${application.id}`"
          >
            <VacancyCard
              :key="`application-card-${application.id}`"
              :vacancy="application"
              :isOpen="false"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import VacancyCard from "../../components/dashboard/VacancyCard.vue";

export default {
  components: { StatisticsCardLine, VacancyCard },
  data: () => ({
    subscribersGainedChartData: {
      series: [
        {
          name: "Subscribers",
          data: [4]
        }
      ]
    },
    total_of_applications: 0,
    total_of_vacancies: 0,
    last_vacancies: [],
    last_applications: []
  }),
  methods: {
    fetchVacancyAndApplication() {
      this.$vs.loading({
        text: "Carregando..."
      });

      const { company_label } = this.$router.history.current.params;

      this.$http
        .get(`/api/v1/talent/${company_label}/user/talent/vacancy`)
        .then(response => {
          this.$vs.loading.close();

          if (
            response.hasOwnProperty("data") &&
            response.data.hasOwnProperty("data")
          ) {
            const { vacancies, applications } = response.data["data"];

            this.total_of_applications = applications.data.length;
            this.total_of_vacancies = vacancies.total;

            if (vacancies.total > 3) {
              this.last_vacancies = vacancies.data
                .slice(0, 3)
                .sort((first, second) => first.id - second.id);
            } else {
              this.last_vacancies = vacancies.data;
            }

            if (applications.data.length > 3) {
              this.last_applications = applications.data
                .slice(0, 3)
                .sort((first, second) => first.id - second.id);
            } else {
              this.last_applications = applications.data;
            }
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.$vs.loading.close();
        });
    }
  },
  created() {
    this.fetchVacancyAndApplication();
  }
};
</script>

<style lang="scss" scoped>
  .nxp-vacancy-cards {
    padding: 24px 16px;
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 1fr;

    }
  }
</style>
